module.exports = __webpack_public_path__ + "92b24e42a315a0c20fe1602b2a76273d.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/goldencity.jpg
// module id = 488
// module chunks = 0